export const adapter = (id) => id;
